import { HeroSection } from './HeroSection';
import { FeaturesGrid } from './FeaturesGrid';
import { HowItWorks } from './HowItWorks';
import { SafetySection } from './SafetySection';
import { PricingSection } from './PricingSection';
import { FinalCTA } from './FinalCTA';
import { LandingFooter } from './LandingFooter';

interface LandingPageProps {
  onGoogleLogin: () => void;
  authError?: string | null;
}

export function LandingPage({ onGoogleLogin, authError }: LandingPageProps) {
  // Check if there's a backend connectivity error
  const isServiceUnavailable = authError?.toLowerCase().includes('fetch') ||
                               authError?.toLowerCase().includes('network') ||
                               authError?.toLowerCase().includes('unavailable');

  return (
    <div className="min-h-screen bg-[#0E1525] flex flex-col">
      {/* Main Content */}
      <main className="flex-1 space-y-0">
        <HeroSection onGoogleLogin={onGoogleLogin} isUnavailable={isServiceUnavailable} />
        <FeaturesGrid />
        <HowItWorks />
        <SafetySection />
        <PricingSection />
        <FinalCTA onGoogleLogin={onGoogleLogin} isUnavailable={isServiceUnavailable} />
      </main>

      {/* Footer */}
      <LandingFooter />
    </div>
  );
}
